import React, { Component } from 'react';
import { render } from 'react-dom';
import { connect } from 'react-redux'
import { v4 } from 'uuid'

import { LoadingVertText, LoadingVertLeftText, LoadingVertRightText } from './loading-v-text'

import Button from '@material-ui/core/Button';

import './jitsuLoader.css'


var colors = [
  'red',
  'blue',
  'green',
  'orange',
  'pink',
  'purple',
]
class JitsuLoader extends Component {
  constructor() {
    super();
    this.state = {
      letterColor: 'red'
    }
  }

  componentDidMount() {

    setInterval(() => {
      this.setState({
        letterColor: colors[Math.floor(Math.random() * colors.length)]
      })
    }, 250)

  }
  render() {
    var {letterColor} = this.state

    return (
      <div style={ { zIndex: "50", position: 'absolute', top: 0, left: 0, backgroundColor: "transparent" } } className="h-100 w-100 d-flex justify-content-center align-items-center">
        <div style={ { zIndex: "1" } } style={ { position: 'absolute', top: 0, left: 0, backgroundColor: "white", opacity: .7 } } className="h-100 w-100">
        </div>
        <div className='jitsu-loader-container'>
          <LoadingVertText {...{ letterColor }}/>
          <LoadingVertLeftText {...{ letterColor }}/>
          <LoadingVertRightText {...{ letterColor }}/>
          <img className='pureYang' src={ "./images/pureyang.png" } alt="" />
        </div>
      </div>
      );
  }
}


const mapStateToProps = (state, ownProps) => ({


})

export default connect(mapStateToProps, {

})(JitsuLoader)


// WEBPACK FOOTER //
// ./src/Components/JitsuLoader/index.js